import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useAndroidBack } from '@/hooks/useAndroidBack';
import { ROUTES } from './routes';
import LoadingScreen from '@/components/ui/LoadingScreen';

/**
 * PrivateRoute — protège les routes authentifiées.
 * Monte aussi useAndroidBack pour que le bouton retour Android
 * fonctionne sur toutes les pages privées.
 */
export default function PrivateRoute() {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  // Bouton retour Android — actif sur toutes les pages privées
  useAndroidBack();

  if (isLoading) return <LoadingScreen />;

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.AUTH} state={{ from: location }} replace />;
  }

  if (!user?.emailVerified) {
    return <Navigate to={ROUTES.EMAIL_VERIFY} replace />;
  }

  return <Outlet />;
}
